import {
  SET_APP_VERSION
} from '../actions'

const initialState = {
  appVersion: null,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_APP_VERSION:
      return {
        ...state,
        appVersion: action.appVersion,
      }
    default:
      return state
  }
}

export default reducer
